module.exports = __webpack_public_path__ + "static/media/warning.48eae2c5.svg";